var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-button',{attrs:{"variant":_vm.variant},on:{"click":_vm.execute}},[(_vm.btnProcessing)?[_c('fa-icon',{attrs:{"icon":"spinner","spin":""}}),_vm._v("   ")]:_vm._e(),_vm._t("default")],2),(_vm.displayedProcessingMessage)?_c('p',[_vm._v(_vm._s(_vm.displayedProcessingMessage))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }